module.exports = __webpack_public_path__ + "img/r6.77a4ad55.jpg";